<template>
  <div class="signin-container">
    <div style="margin-bottom: 100px">
      <div class="store-name">
        <span>{{ storeData.store_display_name }}</span>
      </div>
      <div class="row-info mt15">
        <span>{{ storeData.store_display_address }}</span>
      </div>
      <a :href="`tel:${storeData.store_display_phone}`" class="row-info mt10">
        <span>{{ storeData.store_display_phone }}</span>
      </a>
      <a :href="storeData.store_main_url" class="row-info mt10">
        <span>{{ storeData.store_main_url }}</span>
      </a>
      <div class="body-container information">
        <span class="title mb20 mt30">Customer</span>
        <PhoneInput
          @input="phoneInput"
          :error="phoneNumber.error"
          placeholder="Your Phone Number"
        />
        <div class="text-field">
          <input v-model="fullName.val" class="input" placeholder="Name" />
        </div>
      </div>
      <div class="body-container service">
        <span class="title mb20">Service</span>
        <div class="list-service">
          <service-item
            v-for="(item, index) in services"
            :index="index"
            :key="item.service_id"
            :title="item.type"
            :isSelected="
              selectedServices.find((s) => s.service_id == item.service_id) !=
              null
            "
            v-on:onItemClick="() => onSelectedItem(index)"
          />
        </div>
      </div>
      <div class="body-container technician">
        <span class="title mb20">Request Technician</span>
        <div
          class="btn-technician-container normal-button"
          @click="dialogTechnician = true"
        >
          <span v-if="tech.full_name" class="tect">{{ tech.full_name }}</span>
          <span v-else class="tect-placeholder">Select technician</span>
          <img
            src="@/assets/ic_triangle.png"
            style="height: 15px; widht: auto"
          />
        </div>
      </div>
      <div class="body-container time">
        <div class="datetime-container">
          <div class="date-container">
            <span class="title mb20">Date & Time</span>
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 100%;
              "
            >
              <el-date-picker
                style="width: 200px"
                type="date"
                placeholder="Pick a date"
                v-model="datePicker"
                @change="openTimePicker"
                :picker-options="pickerOptions"
                format="MM/dd"
              ></el-date-picker>
              <el-time-select
                ref="timePicker"
                style="width: 200px"
                v-model="timePicker"
                placeholder="Select time"
                :picker-options="{
                  start: '08:00',
                  step: '00:30',
                  end: '22:00',
                }"
              ></el-time-select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="cta-bottom">
      <gradient-button title="Make a Appoinment" @onClick="onSignIn" />
    </div>
    <el-dialog title="Notes" :visible.sync="dialogNote" :width="dialogWidth">
      <el-input
        v-model="note"
        autocomplete="off"
        placeholder="Enter your notes"
      />
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogNote = false">Cancel</el-button>
        <el-button style="margin-left: 10px" type="primary" @click="onConfirm"
          >Confirm</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogTechnician"
      :width="dialogWidth"
      center="true"
      @close="() => (dialogTechnician = false)"
    >
      <span class="tech-title" slot="title">Technicians</span>
      <div class="list-technician">
        <div
          v-for="(item, index) in technician"
          :key="item.user_id"
          class="btn-tech normal-button"
          v-bind:class="{
            left: index % 3 == 0,
            right: index % 3 == 2,
            center: index % 3 == 1,
          }"
          @click="() => onSelectTech(item)"
        >
          <span class="tech">{{ item.full_name }}</span>
        </div>
      </div>
    </el-dialog>
    <transition name="fade">
      <div v-if="otpDialog" class="overlay" />
    </transition>
    <transition name="slide">
      <div class="bottom-checkout-container confirm-alert" v-if="otpDialog">
        <img src="@/assets/confirmphone.png" class="logo-success" />
        <span class="message">Enter your verification code</span>
        <otp-view :length="6" @onChange="onVerify" class="otp-view" />
        <div
          class="continue-button normal-button"
          v-bind:class="{ 'continue-button-disable': resend > 0 }"
          @click="
            () => {
              resend == 0 && requestOtp();
            }
          "
        >
          <span class="continue-text"
            >Resend {{ resend > 0 ? `(${resend}s)` : "" }}</span
          >
        </div>
      </div>
    </transition>
    <purchase-success-alert
      v-if="isComplete && !isGroup"
      @onDismiss="onDismiss"
      :storeName="displayName"
    />
    <purchase-group-success
      v-if="isComplete && isGroup"
      @onDismiss="onDismiss"
      :urlGroup="urlGroup"
      @onCopyClick="onCopyClick"
    />
  </div>
</template>

<script>
import GradientButton from "@/components/GradientButton";
import PurchaseSuccessAlert from "@/components/PurchaseSuccessAlert";
import PurchaseGroupSuccess from "@/components/PurchaseGroupSuccess";
import {
  getServices,
  getTechnician,
  createTicket,
  getDisplayName,
  requestVerificationCode,
  verifyCode,
  findCustomer,
} from "@/api/home";
import ServiceItem from "./components/ServiceItem";
import { Message, Loading } from "element-ui";
import moment from "moment";
import PhoneInput from "@/components/PhoneInput";
import OtpView from "./components/OtpView";
import debounce from "lodash.debounce";
import SocketUtils from "@/utils/SocketUtils";

export default {
  name: "SignIn",
  components: {
    GradientButton,
    ServiceItem,
    PurchaseSuccessAlert,
    PhoneInput,
    OtpView,
    PurchaseGroupSuccess,
  },
  mounted() {
    document
      .querySelectorAll(".el-date-editor input")
      .forEach((e) => (e.readOnly = true));
  },
  data() {
    return {
      datePicker: "",
      timePicker: "",
      source: "Appointment",
      note: "",
      tech: {},
      fullName: {
        val: "",
        error: "",
      },
      pickerOptions: {
        disabledDate(time) {
          const isToday = moment(time).isSame(new Date(), "day");
          if (isToday) {
            return false;
          } else {
            return time.getTime() < Date.now();
          }
        },
      },
      phoneNumber: {
        obj: {
          number: {
            input: "",
          },
        },
        error: "",
      },
      services: [],
      technician: [],
      selectedServices: [],
      dialogNote: false,
      dialogTechnician: false,
      checked: false,
      displayName: "",
      isComplete: false,
      otpDialog: false,
      resend: 60,
      ticketData: null,
      storeName: null,
      groupId: null,
      groupName: null,
      storeData: {},
    };
  },
  computed: {
    urlGroup() {
      return `${window.location.host}/booking?storename=${this.storeName}&group_id=${this.groupId}&group_name=${this.groupName}`;
    },
    device() {
      return this.$store.state.app.device;
    },
    dialogWidth() {
      if (this.device == "mobile") return "100%";
      return "600px";
    },
    dialogWidthOtp() {
      if (this.device == "mobile") return "80%";
      return "300px";
    },
    phoneInput() {
      const self = this;
      return debounce((val, obj) => {
        if (obj && obj.number && obj.number.national) {
          const formattedNumber = obj.number.national.replace(/\s+/g, "");
          self.autoFullName(formattedNumber);
        }

        if (obj && obj.isValid) {
          self.phoneNumber.error = ""; 
        }

        this.phoneNumber.obj = obj;
      }, 500);
    },
    getDate() {
      if (this.datePicker == "") return "";
      return moment(this.datePicker).format("MM/DD");
    },
    getTime() {
      return this.timePicker;
    },
    todayActive() {
      const diff = moment(this.datePicker).diff(new Date());
      return diff <= 0;
    },
    tomorrowActive() {
      const diff = moment(this.datePicker).diff(new Date());
      return diff > 0 && diff <= 86400000;
    },
  },
  methods: {
    autoFullName(phone) {
      const self = this;
      findCustomer(phone, this.storeName)
        .then((res) => {
          self.fullName.val = res.full_name;
        })
        .catch(() => {
          self.fullName.val = "";
        });
    },
    emitData() {
      if (!this.ticketData) return;
      SocketUtils.socket.emit("ON_BOOKING", {
        store_name: this.storeName,
        ticket_data: this.ticketData,
      });
      this.ticketData = null;
    },
    onVerify(val) {
      const country_code = this.phoneNumber.obj.country.dialCode;
      const phone_number = this.phoneNumber.obj.number.e164.replace(
        "+" + country_code,
        ""
      );
      verifyCode({
        phone_number: phone_number,
        store_name: this.storeName,
        verification_code: val.join(""),
      })
        .then(() => {
          this.isComplete = true;
          this.checked = false;
          this.otpDialog = false;
          this.emitData();
        })
        .catch(() => {});
    },
    requestOtp() {
      const country_code = this.phoneNumber.obj.country.dialCode;
      const phone_number = this.phoneNumber.obj.number.e164.replace(
        "+" + country_code,
        ""
      );
      requestVerificationCode({
        phone_number: phone_number,
        store_name: this.storeName,
      })
        .then((res) => {
          console.log(res);
        })
        .catch((e) => {
          console.log(e);
        });
      this.resend = 60;
      setInterval(() => {
        this.resend -= 1;
      }, 1000);
    },
    openTimePicker() {
      this.$refs.timePicker.focus();
    },
    onCopyClick() {
      Message({
        message: "Copied",
        type: "success",
        duration: 2 * 1000,
      });
    },
    onDismiss() {
      this.isComplete = false;
      if (this.isGroup) {
        setTimeout(() => {
          location.reload();
        }, 1000);
      } else {
        location.reload();
      }
    },
    onSelectTech(tech) {
      this.tech = tech;
      this.dialogTechnician = false;
    },
    onConfirm() {
      this.dialogNote = false;
      const other = this.services.find((s) => s.type == "Other");
      const indexSelected = this.selectedServices.indexOf(other);
      if (this.note != "") {
        if (indexSelected > -1) return;
        this.selectedServices.push(other);
      } else {
        if (indexSelected > -1) {
          this.selectedServices.splice(indexSelected, 1);
        }
        return;
      }
    },
    onSignIn() {
      let ms = 0;
      if (this.timePicker != "") {
        ms =
          Number(this.timePicker.split(":")[0]) * 60 * 60 * 1000 +
          Number(this.timePicker.split(":")[1]) * 60 * 1000;
      }
      const mls =
        new Date(moment(this.datePicker).format("MM/DD/YYYY")).getTime() + ms;
      let error = "";
      if (!this.storeName) {
        error = "Invalid Store Name";
      } else if (this.selectedServices.length == 0) {
        error = "Please choose service";
      } else if (this.phoneNumber.obj.number.input == "") {
        error = "Please fill your phone number";
      } else if (this.fullName.val == "") {
        error = "Please fill your name";
      } else if (!this.phoneNumber.obj.valid) {
        error = "Invalid phone number";
      } else if (mls < new Date().getTime()) {
        error = "Please select valid time";
      }
      if (error != "") {
        Message({
          message: error,
          type: "error",
          duration: 5 * 1000,
        });
        return;
      }
      const loadingInstance = Loading.service({ fullscreen: true });
      const country_code = this.phoneNumber.obj.country.dialCode;
      const phone_number = this.phoneNumber.obj.number.replace(
        "+" + country_code,
        ""
      );
      const body = {
        requested_id: this.tech.user_id || 0,
        phone_number: phone_number,
        country_code: "+" + country_code,
        full_name: this.fullName.val,
        customer_source: this.source,
        service_ids: this.selectedServices.map((s) => s.service_id),
        assignee_id: this.technician[0].user_id,
        other_notes: this.note,
        store: this.storeName,
        agreement_checked: this.checked,
        notes: "",
        time_slot: moment(new Date(mls))
          .utc()
          .format("YYYY-MM-DD hh:mm:ss.SSSZ"),
        is_booking: true,
      };
      if (this.isGroup) {
        this.groupId = Math.round(new Date().getTime() / 1000);
        this.groupName = this.fullName.val;
        body.group_id = this.groupId;
        body.group_name = this.groupName;
      }
      if (this.groupId) {
        body.group_id = this.groupId;
        body.group_name = this.groupName;
      }
      createTicket(body)
        .then((res) => {
          this.ticketData = res;
          loadingInstance.close();
          if (!res.customer.is_phone_number_valid) {
            this.otpDialog = true;
            this.requestOtp();
          } else {
            this.isComplete = true;
            this.checked = false;
            this.emitData();
          }
        })
        .catch((e) => {
          loadingInstance.close();
          console.log(e.message);
        });
    },
    onSelectedItem(index) {
      const item = this.services[index];
      if (item.type == "Other") {
        this.dialogNote = true;
        return;
      }
      const isSelected =
        this.selectedServices.find((s) => s.service_id == item.service_id) !=
        null;
      if (isSelected) {
        const indexSelected = this.selectedServices.indexOf(item);
        if (indexSelected > -1) {
          this.selectedServices.splice(indexSelected, 1);
        }
      } else {
        this.selectedServices.push(item);
      }
    },
  },
  created() {
    this.storeName = this.$route.query.storename;
    this.isGroup = this.$route.query.group;
    this.groupId = this.$route.query.group_id;
    this.groupName = this.$route.query.group_name;
    if (!this.storeName) {
      Message({
        message: "Invalid Store Name",
        type: "error",
        duration: 5 * 1000,
      });
      return;
    }
    Promise.all([
      getServices(),
      getTechnician(this.storeName),
      getDisplayName(this.storeName),
    ])
      .then((res) => {
        this.services = res[0];
        this.technician = res[1];
        this.storeData = res[2];
      })
      .catch((e) => console.log(e));
  },
};
</script>

<style>
.el-dialog--center .el-dialog__body {
  padding: 20px !important;
}
</style>

<style lang="scss" scoped>
.tech {
  color: #222222;
}
.vue-otp-2 {
  display: flex;
  justify-content: space-evenly !important;
  padding: 0 30px !important;
  div {
    input {
      max-width: 40px !important;
    }
  }
}
.slide-enter-active {
  transition: all 0.3s ease;
}
.slide-leave-active {
  transition: all 0.3s ease;
}
.slide-enter, .slide-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(295px);
}
.bottom-checkout-container {
  background-color: white;
  display: flex;
  flex-direction: column;

  .logo-success {
    width: auto;
    height: 100px;
    align-self: center;
    margin-top: 20px;
  }
  .message {
    font-size: 16px;
    font-family: "SFUIText-Medium", -apple-system;
    font-weight: 500;
    padding: 0 60px;
    align-self: center;
    margin-top: 30px;
    margin-bottom: 30px;
    text-align: center;
  }
  .phone {
    font-size: 16px;
    font-family: "SFUIText-Bold", -apple-system;
    font-weight: bold;
    align-self: center;
    margin-top: 16px;
  }
  .otp-view {
    margin-left: calc(50% - 250px);
    margin-right: calc(50% - 250px);
  }
  .continue-button {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
    background-image: linear-gradient(to bottom right, #ff4e54, #ff7569);
    border-radius: 5px;
    margin-left: calc(50% - 250px);
    margin-right: calc(50% - 250px);
    margin-top: 30px;
    margin-bottom: 20px;
  }
  .continue-button-disable {
    background-image: linear-gradient(to bottom right, #dddddd, #dddddd);
  }
  @media only screen and (max-width: 600px) {
    .continue-button {
      margin-left: 20px;
      margin-right: 20px;
    }
  }
  .continue-text {
    color: white;
    font-size: 16px;
    font-family: "SFUIText-Semibold", -apple-system;
    font-weight: 600;
  }
}
.confirm-alert {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 4;
}
.overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  background-color: rgba($color: #000000, $alpha: 0.5);
}
.signin-container {
  display: flex;
  flex-direction: column;
  color: #222222;
  padding-left: 70px;
  padding-right: 70px;
  background-color: white;
  .tech-title {
    font-family: "SFProText-Bold", -apple-system;
    font-weight: bold;
    font-size: 18px;
  }
  .row-info {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .store-name {
    font-family: "SFProText-Bold", -apple-system;
    font-weight: bold;
    font-size: 26px;
    margin-top: 30px;
    text-align: center;
  }
  .body-container {
    display: flex;
    flex-direction: column;
    ::placeholder {
      color: #696969;
      font-family: "SFProText-Medium", -apple-system;
      font-weight: 500;
    }
    .text-field {
      margin-bottom: 20px;
    }
    .input {
      width: 100%;
      border-radius: 5px;
      border: 1px solid #eeeeee;
      background-color: #fafafa;
      height: 50px;
      font-size: 16px;
      font-family: "SFProText-Medium" -apple-system;
      font-weight: 500;
      outline: none;
      outline-style: none;
      padding: 0 20px;
      box-shadow: none;
    }
  }
  .information {
    margin: 0 20px 0 20px;
    .source-view {
      width: 200px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 25px;
      .source-text {
        font-family: "SFProText-Bold", -apple-system;
        font-weight: bold;
        font-size: 20px;
      }
    }
  }
  .service {
    margin: 10px 20px 0 20px;
    .list-service {
      display: flex;
      flex-wrap: wrap;
    }
  }
  .technician {
    margin: 15px 20px 0 20px;
    .btn-technician-container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 15px;
      height: 50px;
      border: 1px solid #eeeeee;
      border-radius: 5px;
      background-color: #fafafa;
      .tect-placeholder {
        font-weight: 600;
        color: #9b9b9b;
      }
      .tech {
        font-weight: 600;
      }
    }
  }
  .time {
    margin: 30px 20px 10px 20px;
    .datetime-container {
      display: flex;
      flex: 1;
      flex-direction: column;
      .option {
        padding: 10px 15px;
        background-color: #fafafa;
        border: 1px solid #eeeeee;
        border-radius: 5px;
        font-size: 16px;
        font-family: "SFProText-Medium", -apple-system;
        font-weight: 500;
      }
      .option-active {
        background-color: #dddddd;
        border: none;
      }
      .date-container {
        display: flex;
        flex-direction: column;
        flex: 1;
        align-items: flex-start;
      }
      .time-container {
        display: flex;
        flex-direction: column;
        flex: 1;
        margin-top: 30px;
      }
    }
    .btn-time-container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 15px;
      height: 50px;
      border: 1px solid #eeeeee;
      border-radius: 5px;
      background-color: #fafafa;
      margin: 20px 0;
    }
  }
  .list-technician {
    display: flex;
    flex-wrap: wrap;
  }
  .btn-tech {
    padding: 15px 6px;
    border: 1.5px solid #eeeeee;
    border-radius: 6px;
    width: calc(33% - 5px);
    margin-bottom: 10px;
  }
  .left {
    margin-right: 5px;
  }
  .right {
    margin-left: 5px;
  }
  .center {
    margin-left: 5px;
    margin-right: 5px;
  }
  .tech {
    font-family: "SFProText-Medium", -apple-system;
    font-weight: 500;
    font-size: 16px;
  }
  .title {
    font-family: "SFProText-Bold", -apple-system;
    font-weight: bold;
    font-size: 20px;
  }
  .agreement {
    flex-direction: row;
    margin: 30px 20px 0 20px;
    .agree-text {
      font-family: "SFProText-Regular", -apple-system;
      font-size: 18px;
    }
    .icon-check {
      width: auto;
      height: 20px;
      margin-right: 20px;
    }
  }
  .cta-bottom {
    position: fixed;
    height: 100px;
    left: calc(50% - 300px);
    right: calc(50% - 300px);
    bottom: 0px;
    padding-top: 20px;
    padding-left: 20px;
    padding-right: 20px;
    background-color: white;
  }
}
@media only screen and (max-width: 600px) {
  .signin-container {
    padding-left: 0;
    padding-right: 0;
    .cta-bottom {
      left: 20px;
      right: 20px;
      padding-left: 0px;
      padding-right: 0px;
    }
    .tech {
      font-size: 14px;
    }
    .btn-tech {
      width: calc(33% - 6px);
    }
  }
}
</style>